import { Directive, HostListener, Self } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { FormDebugService } from '../services/form-debug.service';

@Directive({
  selector: '[formGroup]'
})
export class FormDebugDirective {

  constructor(
    @Self() private formGroupDir: FormGroupDirective,
    private formDebug: FormDebugService
  ) {}

  @HostListener('submit')
  onSubmit(): void {
    this.logDebug('submit');
  }

  @HostListener('click', ['$event.target'])
  onClick(target: HTMLElement): void {
    if (target.closest('button, [type="submit"], .btn')) {
      this.logDebug('click');
    }
  }

  private logDebug(trigger: string): void {
    const form = this.formGroupDir.form;
    if (!form.valid) {
    }
  }

  private guessName(): string {
    const keys = Object.keys(this.formGroupDir.form.controls);
    return `Form[${keys.slice(0, 3).join(',')}${keys.length > 3 ? '...' : ''}]`;
  }
}
